import { template } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Card, CardContent, Grid, Icon } from '@mui/material'

const CardToMuchData = ({
    nbElements = 0,
    maxNbElements = 10000,
    forceDisplay = () => { },
}) => {
    return (
        <Card sx={{ backgroundColor: '#ff9800' }}>
            <CardContent sx={{ color: 'white' }}>
                <Grid container columnSpacing={2} alignItems='center'>
                    <Grid size='auto'>
                        <Icon fontSize='large'>warning</Icon>
                    </Grid>
                    <Grid container size='grow' spacing={0.5}>
                        <Grid size={12}>
                            <h6 style={{ fontWeight: 'bold', margin: '0px' }}>
                                {i18n.tooMuchDataToShow}
                            </h6>
                        </Grid>
                        <Grid size='auto'>
                            <h6 style={{ margin: '0px' }}>
                                {template(i18n.performanceDisplayMessage)({ nbElements, maxNbElements })}
                            </h6>
                        </Grid>
                        <Grid size='auto'>
                            <h6 className='textLink' style={{ margin: '0px' }} onClick={forceDisplay}>
                                {i18n.displayEverything}
                            </h6>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

CardToMuchData.propTypes = {
    nbElements: PropTypes.number,
    maxNbElements: PropTypes.number,
    forceDisplay: PropTypes.func,
}

export default CardToMuchData